import { TimelineMax } from 'gsap';
import { searchRefs } from './searchRefs';
export const createGsapTransition = (refsMap, animation) => {
    const master = new TimelineMax();
    if (animation) {
        animation.forEach(({ refs, duration, from, to, delay, stagger }, index) => {
            const targets = typeof refs !== 'string' ? refs.map(ref => refsMap.current.get(ref)) : searchRefs(refsMap, refs);
            if (stagger) {
                master.staggerFromTo(targets, duration, from, to, stagger);
            }
            else {
                master.fromTo(targets, duration, from, to, delay);
            }
        });
    }
    return master;
};
//# sourceMappingURL=animate.js.map